module.exports = __webpack_public_path__ + "static/monster-phone-animation-desktop-644f80bbcdc3662fd114cc8d03cbaee5.gif";